// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "html[data-v-18773676],\nbody[data-v-18773676],\n.v-application--wrap[data-v-18773676] {\n  background: #0a0f19 !important;\n  overflow: hidden;\n}\n", ""]);
// Exports
module.exports = exports;
